<template>
    <form autocomplete="off" class="">
        <CommonSpinner v-if="isLoading" :box="true" />
        <div class="row gy-3">
            <div class="col-lg-12">
                <label> Highest Qualification <span class="text-danger">*</span></label>
                <multiselect  mode="single" searchable valueProp="id"
                    trackBy="institution_title" label="institution_title"
                    :options="academicRecordOptions" 
                    v-model="form.highest_qualification_id" placeholder="--select education --">
                    <template v-slot:option="{ option }">
                        <div class="">
                            <strong class="mb-0 d-block">{{ option.institution_title }}</strong>
                            <div>{{ option.qualification_title }} <span v-if="option.qualification_description">- {{ option.qualification_description }}</span></div>
                        </div>
                    </template>
                </multiselect>
                <div v-for="(item, index) in v$.form.highest_qualification_id.$errors"
                    :key="index" class="text-danger small">
                    <span v-if="item.$message">{{ item.$message }}</span>
                </div>
            </div> 
            <div class="col-lg-6">
                <label> salary range <span class="text-danger">*</span></label>
                <multiselect  mode="single" searchable valueProp="id"
                    trackBy="title" label="title"
                    :options="salaryRangeOptions" 
                    v-model="form.salary_range_id" placeholder="--select range --">
                    <template v-slot:option="{ option }">
                        <div class="">
                           {{ option.title }}
                        </div>
                    </template>
                </multiselect>
                <div v-for="(item, index) in v$.form.salary_range_id.$errors"
                    :key="index" class="text-danger small">
                    <span v-if="item.$message">{{ item.$message }}</span>
                </div>
            </div> 
            
            <div class="col-lg-6">
                <label class="form-label">Work type  <span class="text-danger">*</span></label>
                <select v-model="form.work_type" class="form-select"
                    :class="{ 'is-invalid': v$.form.work_type.$error }">
                    <option disabled value="" >--select--</option>
                    <option v-for="(option, uIndex) in workTypes" :key="uIndex" 
                    :value="option.value">{{option.label}}</option>
                </select>
                <div v-for="(item, index) in v$.form.work_type.$errors"
                    :key="index" class="invalid-feedback">
                    <span v-if="item.$message">{{ item.$message }}</span>
                </div>
            </div>

            <div class="col-12">
                <label class="form-label">Write a brief information about you</label>
                <textarea v-model="form.about" class="form-control"
                rows="7" placeholder="Write something" name="about"
                :class="{ 'is-invalid': v$.form.about.$error }"></textarea>
                <small>Maximum characters: 2000</small>
                <div v-for="(item, index) in v$.form.about.$errors"
                    :key="index" class="invalid-feedback">
                    <span v-if="item.$message">{{ item.$message }}</span>
                </div>
            </div>
            <div class="col-12">
                <div class="d-flex mt-3 justify-content-end">
                    <b-button variant="primary" 
                    @click.prevent="editMode? update() : create()"
                     type="button">{{editMode? 'Update':'Submit'}}</b-button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { required, helpers, requiredIf, maxLength } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";


export default {
    setup() {
        return { v$: useVuelidate() };
    },
    props:{
        editItem:{
            type: Object,
            default: null
        },
        editMode:{
            type: Boolean,
            default: true
        }
    },
    data(){
        return{
            isLoading: true,
            form: {
                highest_qualification_id: null,
                salary_range_id: null,
                work_type: "",
                about: "",
            },
            academicRecordOptions:[],
            salaryRangeOptions: [],
            workTypes:[
                { value: "contract", label: "Contract" },
                { value: "full-time", label: "Full time" },
                { value: "internship", label: "Internship" },
                { value: "part-time", label: "Part time" }
            ]
        }
    },
    validations() {
        return {        
            form:{
                highest_qualification_id: {
                    required: helpers.withMessage("Higest Education is required", required),
                },
                salary_range_id: {
                    required: helpers.withMessage("Expected Salary range is required", required),
                },
                work_type: {
                    required: helpers.withMessage("Work type is required", required),
                },
                about: {
                    maxLength: helpers.withMessage("About information should not be more than 2000 characters",  maxLength(2000)),
                },
            },
        }
    },
    methods:{
        update(){
            this.v$.$validate().then(result =>{
                if (!result) { this.alertError(this.v$.$errors[0].$message); return };

                this.$store.dispatch("changeLoaderValue", true)
                this.$http.post('/profile-settings/update', this.form)
                    .then((response) => {
                        this.$store.dispatch("changeLoaderValue", false)
                        if(response.data.success){
                            this.$emit('updatedItem', response.data.data)
                            this.resetForm()
                        }
                    })
            
            })
        },
        resetForm(){
            this.v$.$reset()
            this.$emit("closeMe")
        },
        getOptionData(){
            this.isLoading = true
            this.$http.get(this.absoluteApiUrl('/salary-ranges')).then((response) => {
                if(response.data.success){
                    this.salaryRangeOptions = response.data.data
                }
            })
            this.$http.get('/academic-records/all').then((response) => {
                this.isLoading = false
                if(response.data.success){
                    this.academicRecordOptions = response.data.data
                }
            })
        },
    },
    created(){
        this.getOptionData()
        this.form = this.$filters.patchUpdatables(this.form, this.editItem)
    }
}
</script>